import AIVideoModal from './AiVideoModal'

export default AIVideoModal
